<template lang="html">
  <div class="client-resume">
    <div class="vx-row">
      <div class="vx-col md:w-1/2 ml-auto w-full mt-5">
        <h6 class="text-primary font-semibold">
          {{ $t('company') | capitalize }}
        </h6>
        <table>
          <tr>
            <td class="font-semibold">{{ $t('name') | capitalize }}:</td>
            <td class="pl-2">{{ companyInfo.name }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $t('rfc') | upperCase }}:</td>
            <td class="pl-2">{{ companyInfo.rfc }}</td>
          </tr>
          <tr>
            <td class="font-semibold">
              {{ $t('representative') | capitalize }}:
            </td>
            <td class="pl-2">{{ companyInfo.representative }}</td>
          </tr>
          <tr>
            <td class="font-semibold">
              {{ $t('manager_name') | capitalize }}:
            </td>
            <td class="pl-2">{{ companyInfo.managerName }}</td>
          </tr>
          <tr>
            <td class="font-semibold">
              {{ $t('manager_email') | capitalize }}:
            </td>
            <td class="pl-2">{{ companyInfo.managerEmail }}</td>
          </tr>
          <tr>
            <td class="font-semibold">
              {{ $tc('manager_phone') | capitalize }}:
            </td>
            <td class="pl-2">{{ companyInfo.managerPhone }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $t('address') + ' 1'| capitalize }}:</td>
            <td class="pl-2">{{ companyInfo.address1 }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $t('address') + ' 2'| capitalize }}:</td>
            <td class="pl-2">{{ companyInfo.address2 }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $t('city') | capitalize }}:</td>
            <td class="pl-2">{{ companyInfo.addressCity }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $t('state') | capitalize }}:</td>
            <td class="pl-2">{{ companyInfo.addressState }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $t('number') | capitalize }}:</td>
            <td class="pl-2">{{ companyInfo.addressNumber }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $t('zip') | upperCase }}:</td>
            <td class="pl-2">{{ companyInfo.addressZip }}</td>
          </tr>
        </table>
      </div>
      <div class="vx-col md:w-1/2 mr-auto w-full mt-5">
        <h6 class="text-primary font-semibold">
          {{ $t('client') | capitalize }}
        </h6>
        <table>
          <tr>
            <td class="font-semibold">{{ $t('name') | capitalize }}:</td>
            <td class="pl-2"> {{ client.name}} </td>
          </tr>
          <tr>
            <td class="font-semibold">
              {{ $t('short_name') | upperCase }}:
            </td>
            <td class="pl-2">{{ client.shortName}}</td>
          </tr>
          <tr>
            <td class="font-semibold">
              {{ $t('sca_file_name') | capitalize }}:
            </td>
            <td class="pl-2">{{ client.scaFileName }}</td>
          </tr>
          <tr>
            <td class="font-semibold">
              {{ $t('mxn_funds_transfer') | capitalize }}:
            </td>
            <td class="pl-2">{{ client.mxnFundsTransferInfo }}</td>
          </tr>
          <tr>
            <td class="font-semibold">
              {{ $t('usd_funds_transfer') | capitalize }}:
            </td>
            <td class="pl-2">{{ client.usdFundsTransferInfo }}</td>
          </tr>
          <tr>
            <td class="font-semibold">
              {{ $tc('schedule_day_invoice') | capitalize }}:
            </td>
            <td class="pl-2">{{ client.scheduleDayInvoice }}</td>
          </tr>
          <tr>
            <td class="font-semibold">
              {{ $t('darwin_account') | capitalize }}:
            </td>
            <td class="pl-2">{{ client.darwinAccount }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $t('color') | capitalize }}:</td>
            <td class="pl-2">{{ client.color }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $t('code') | capitalize }}:</td>
            <td class="pl-2">{{ client.code }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 ml-auto w-full mt-5">
        <h6 class="text-primary font-semibold">
          {{ $t('headquarter') | capitalize }}
        </h6>
        <table>
          <tr>
            <td class="font-semibold">{{ $t('name') | capitalize }}:</td>
            <td class="pl-2">{{ headquarter.name }}</td>
          </tr>
          <tr>
            <td class="font-semibold">
              {{ ($t('address') + ' 1') | upperCase }}:
            </td>
            <td class="pl-2">{{ headquarter.address1 }}</td>
          </tr>
          <tr>
            <td class="font-semibold">
              {{ ($t('address') + ' 2') | capitalize }}:
            </td>
            <td class="pl-2">{{ headquarter.address2 }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $t('city') | capitalize }}:</td>
            <td class="pl-2">{{ headquarter.addressCity }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $t('zip') | upperCase }}:</td>
            <td class="pl-2">{{ headquarter.addressZip }}</td>
          </tr>
        </table>
      </div>
      <div class="vx-col md:w-1/2 mr-auto w-full mt-5">
        <h6 class="text-primary font-semibold">
          {{ $t('recipients') | capitalize }}
        </h6>
        <table>
          <thead>
            <tr>
              <th class="detail-th">{{ $t('name') | capitalize }}</th>
              <th class="detail-th pl-2">{{ $t('email') | capitalize }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,index) in recipients">
              <td>{{item.name}}</td>
              <td class="pl-2">{{item.email}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: ['client',
    'companyInfo',
    'recipients',
    'headquarter'
  ]

}
</script>

<style lang="css" scoped>
.client-resume{

    font-size: 14px;
}

</style>
